<template>
  <w-dialog :border="true" closeFree width="552px"  top="calc(50vh - 250px)" @ok="onOk" title="发表评论" v-model="visible" class="pop-comment">
    <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="评论内容" prop="comments">
          <el-input type="textarea" v-model="form.comments" :rows='4' maxlength="64" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="附件" prop="img">
          <div class="tips">（大小限制在4M以内，格式支持jpg，png）</div>
          <imageUpload :imgList="imgList" :maxSize="4"></imageUpload>
        </el-form-item>
    </el-form>
  </w-dialog>
</template>

<script>
import imageUpload from '@/components/imageUpload.vue'
export default {
  name: "popComment",
  components: {imageUpload},
  data() {
    return {
      visible: false,
      form:{
        comments:''
      },
      imgList:[],
      rules: {
        comments: [
            { required: true, message: '请输入评论', trigger: 'blur' },
          ]
        }
    }
  },
  created() {

  },
  mounted() {
    // this.getOrgList()
  },
  methods: {
    show() {
      this.form.comments = ''
      this.imgList = []
      this.visible = true
    },
    onOk() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.imageUrls = this.imgList.map(e=>e.url)
          console.log('>>',this.form)
          this.$emit('ok', this.form)
          // return false
          this.visible = false
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      
  },
}
}
</script>

<style lang="scss" scoped>
.pop-comment /deep/{
  .el-dialog__header{
    padding: 16px 0 0;
    height: 54px;
    box-sizing: border-box;
  }
  .el-dialog__body{
    padding: 16px 36px 0 32px;
  }
  .el-form-item{
    margin-bottom: 26px;
  }
  .el-dialog__footer{
    padding: 6px 0 16px;
  }
  .tips{
    color: #939696;
    font-size: 12px;
  }
}
</style>
